import {
  BaseUrl,
  getRequest,
  postRequest
} from '@/libs/axios.js'
// let mApi = window.$config.thost
window.$config.thost = vocationalVal.thost
let mApi = vocationalVal.thost;
const loginResponse = (res) => {
  if (res.meta && res.meta.code === 0) {
    let data = res.data
    return data
  } else {
    // (res.meta && res.meta.message) || '操作失败'
    $toast(res.meta.message)
  }
}

/**
 * 登录
 */
export async function webLogin (params, type) {
  // return postRequest(`${mApi}/open/v1/webLogin`, params);
  return postRequest(`${mApi}/auth/open/v1/webLogin`, params, type);
}

/**
 * 获取二维码
 */
export async function getWebQRCode (params) {

  return getRequest(`${mApi}/auth/open/v1/getWebQRCode`, params);
}

/**
 * 退出登录
 */
export async function webLoginOut (params) {

  return postRequest(`${mApi}/auth/open/v1/webLoginOut`, params);
}
/**
 * 微信扫码登录(轮询查询登录接口
 */
export async function pollingWebQRCodeLoginStatus (params) {

  return getRequest(`${mApi}/auth/open/v1/pollingWebQRCodeLoginStatus`, params);
}

// 获取个人信息
export async function getMyUserInfo (params) {
  // return getRequest(`${mApi}/person/unify/v1/getMyUserInfo`, params);
  return getRequest(`${mApi}/quingno/person/unify/v1/getMyUserInfo`, params);
}
// 忘记密码
export async function changeAccountPwd (params) {
  // return postRequest(`${mApi}/account/unify/v1/changeAccountPwd`, params);
  return postRequest(`${mApi}/auth/account/unify/v1/changeAccountPwd`, params);
}
// 修改密码
export async function updatePwd (params) {
  // return postRequest(`${mApi}/account/unify/v1/changeAccountPwd`, params);
  return postRequest(`${mApi}/auth/account/unify/v1/updatePwd`, params);
}
// 修改密码发送验证码
export async function sendChangeLyPwdSms (params) {
  // return postRequest(`${mApi}/account/unify/v1/sendChangeLyPwdSms`, params);
  return postRequest(`${mApi}/auth/account/unify/v1/sendChangeLyPwdSms`, params);
}
// 修改手机号发送验证码
export async function sendChangePhoneSms (params) {
  // return postRequest(`${mApi}/account/unify/v1/sendChangePhoneSms`, params);
  return postRequest(`${mApi}/auth/account/unify/v1/sendChangePhoneSms`, params);
}

// 发送验证码
export async function verifiWebCode (params, type) {
  // return postRequest(`${mApi}/account/unify/v1/sendChangePhoneSms`, params);
  return getRequest(`${mApi}/auth/open/v1/verifiWebCode`, params, type);
}

// todo  返回手机号的验证码
export async function verifyWebCode (params, type) {
  return getRequest(`${mApi}/auth/open/v2/verifiWebCode`, params, type);
}
// 修改手机号
export async function changeAccountPhone (params) {
  // return postRequest(`${mApi}/account/unify/v1/changeAccountPhone`, params);
  return postRequest(`${mApi}/auth/account/unify/v1/changeAccountPhone`, params);
}
// 获取图形验证码
export async function getCaptcha (params) {
  return getRequest(`${mApi}/auth/account/unify/v1/getCaptcha`, params);
}
// 校验图形验证码
export async function verification (params) {
  return getRequest(`${mApi}/auth/account/unify/v1/verification`, params);
}

// 龙岩
export async function checkAppToken (params) {
  // return getRequest(`${mApi}/oauth/v1/checkAppToken`, params);
  return getRequest(`${mApi}/auth/oauth/v1/checkAppToken`, params);
}


export async function twoFactorCallBack (params) {
  // return getRequest(`${mApi}/oauth/v1/checkAppToken`, params);
  return getRequest(`${mApi}/auth/oauth/v1/twoFactorCallBack`, params);
}

// 登录方式
export async function getLoginManageByType (params) {
  return getRequest(`${mApi}/auth/loginManage/open/v1/getLoginManageByType`, params);
}

export async function unifyTwoFactorCallBack (params) {
  // return getRequest(`${mApi}/oauth/v1/checkAppToken`, params);
  return getRequest(`${mApi}/auth/oauth/unify/v1/twoFactorCallBack`, params);
}

export async function unifyVerifyCode (params) {
  // return getRequest(`${mApi}/oauth/v1/checkAppToken`, params);
  return getRequest(`${mApi}/auth/oauth/unify/v1/verifiCode`, params);
}


// 天气
export async function getDayWeather (params) {
  // return getRequest(`${mApi}/oauth/v1/checkAppToken`, params);
  return getRequest(`${mApi}/manage/weather/open/v1/getDayWeather`, params);
}


// 获取工作列表总数
export async function getTodoCount (params) {
  return getRequest(`${mApi}/manage/workflow/unify/v1/getTodoCondition`, params);
  // return getRequest(`${mApi}/workflow/todo/unify/v1/getTodoCount`, params);
}
/*工作列表  */
export async function getTodoList (params) {
  return getRequest(`${mApi}/workflow/todo/unify/v1/getTodoList`, params);
}
/*工作列表跳转详情  */
export async function getTodoInfo (params) {
  return getRequest(`${mApi}/workflow/todo/unify/v1/getTodoInfo`, params);
}

// 应用列表全量
export async function getServiceListByGroupType (params) {
  return getRequest(`${mApi}/operation/service/unify/v1/getServiceListByGroupType`, params);
}

//添加应用
export async function saveBatchMyService (params) {
  return postRequest(`${mApi}/operation/kyy/unify/v1/saveBatchMyService`, params);
}

//我的应用
export async function getMyQuickAppList (params) {
  return getRequest(`${mApi}/operation/kyy/unify/v1/getMyQuickAppList`, params);
}

// 校园官网文章列表
export async function getListByContentId (params) {
  return getRequest(`${mApi}/cms/cmsArticle/unify/v1/getListByContentId`, params);
}


// 通知公告
export async function getArticleListByType (params) {
  return getRequest(`${mApi}/cms/cmsArticle/unify/v1/getArticleListByType`, params);
}
export async function getArticleInfoById (params) {
  return getRequest(`${mApi}/cms/cmsArticle/unify/v1/getArticleInfoById`, params);
}
//问题反馈
export async function insertProPosal (params) {
  return postRequest(`${mApi}/manage/feedback/unify/v1/insertProPosal`, params);
}

export async function searchProposalList (params) {
  return getRequest(`${mApi}/manage/feedback/unify/v1/searchProposalList`, params);
}

export async function searchProPosalDTOById (params) {
  return getRequest(`${mApi}/manage/feedback/unify/v1/searchProPosalDTOById`, params);
}
// 搜素应用
export async function searchFromStore (params) {
  return getRequest(`${mApi}/auth/develop/unify/v1/searchFromStore`, params);
}

// 我的待办列表   
export async function getTodoListManage (params, index) {
  if (index == 1) {//待办
    return getRequest(`${mApi}/manage/workflow/unify/v1/getTodoList`, params);
  } else if (index == 2) {//待阅
    return getRequest(`${mApi}/manage/workflow/unify/v1/getMatterRead`, params);

  } else if (index == 3) {//待认领
    return getRequest(`${mApi}/manage/workflow/unify/v1/getBackLog`, params);

  } else if (index == 4) {//已办
    return getRequest(`${mApi}/manage/workflow/unify/v1/getHadDone`, params);

  } else if (index == 5) {//已阅
    return getRequest(`${mApi}/manage/workflow/unify/v1/getHadRead`, params);

  } else if (index == 6) {//已发起
    return getRequest(`${mApi}/manage/workflow/unify/v1/getHadstarted`, params);

  } else if (index == 7) {//已撤回
    return getRequest(`${mApi}/manage/workflow/unify/v1/getUndo`, params);

  }

}

// 获取消息
export async function getNoticeList (params) {
  return getRequest(`${mApi}/quingkchat/collect/unify/v1/getNoticeList`, params);
}